import React, { useEffect, useState } from "react";
import { MediaAttachment } from "src/shared/types/src";
import { MEDIA_TYPE } from "src/shared/config/src";
import LocalImages from '../../../static';
import { Spinner } from "reactstrap";
import { PlayCircle } from "react-ionicons";
import { Document, Page, pdfjs } from 'react-pdf'

type iProps = { 
    media: MediaAttachment, 
    collageDisplay: boolean ,
    largePlayIcon?: boolean 
}

const  MediaTypeDisplay: React.FC<iProps> = ({ media, collageDisplay, largePlayIcon }) => {

    const [mediaType, setMediaType] = useState<string>('image');
    const [mediaPath, setMediaPath] = useState<string>('');
    const [imageLoading, setImageLoading] = useState<boolean>(false);
    const [numPages, setNumPages] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const { contentType, url } = media.media;
        let mediaTypeLocal = MEDIA_TYPE.IMAGE;

        if (contentType === 'application/pdf') {
            mediaTypeLocal = MEDIA_TYPE.PDF;
        } else if (contentType.includes('image')) {
            mediaTypeLocal = MEDIA_TYPE.IMAGE;
        } else {
            mediaTypeLocal = MEDIA_TYPE.VIDEO;
        }

        setMediaType(mediaTypeLocal);

        if (mediaTypeLocal === MEDIA_TYPE.IMAGE) {
            setMediaPath((collageDisplay) ? media.thumb.url : media.media.url);
        }

        if (mediaTypeLocal === MEDIA_TYPE.VIDEO) {
            setMediaPath(media.thumb.url);
        }

    }, [media, collageDisplay]);

    const renderLoadingOverlay = () => {
        return (
            <div>
                <p>Loading...</p>
            </div>
        )
    };

    const renderImageView = () => {
        return (
            <>
                <img src={mediaPath} alt="media" />
                {imageLoading && renderLoadingOverlay()}
            </>
        )
    }

    const RenderImage = ({ mediaPath, customStyle }: { mediaPath: string, customStyle: any }) => {
        return (
            <>
                {
                    (mediaPath.endsWith('.svg')) ?
                        <img src={mediaPath}/> :
                        mediaPath ? renderImageView() : null
                }
            </>
        )
    }

    const renderVideoContent = () => {
        return (
            <>
                <RenderImage mediaPath={mediaPath} customStyle={{ objectFit: 'cover' }} />
                <div className="video-play-btn">
                    <div className="video-play-icon-btn">
                        {media.isProcessing ? 
                            <div className="processing-video-container">
                                <Spinner />
                                <p className="fs-12 text-black">Processing...</p>
                            </div> 
                            : 
                            <PlayCircle
                                color={'#FFFFFF'}
                                height={largePlayIcon ? "64px" : "40px"}
                                width={largePlayIcon ? "64px" : "40px"}
                            />
                        }
                    </div>
                </div>
            </>
        )
    }

    const renderVideo = () => {
        if (collageDisplay) {
            return renderVideoContent()
        }
        return (
            <video width={'100%'} height={'100%'} controls>
                <source src={media?.media?.url} type="video/mp4" />
                    Your browser does not support the video tag.
            </video>
        )
    }

    const renderAudio = () => {
        if (collageDisplay) {
            return (
                <div className="audio-play-btn">
                    <div className="audio-play-icon-btn">
                        <img src={LocalImages.audioIcon} alt="audio" style={{ objectFit: 'contain', width: 'auto', height: 'auto' }} />
                    </div>
                </div>
            )
        }

        return (
            <audio controls>
                <source src={media?.media?.url} type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
        )

    }

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    }

    const renderPDF = () => {
        if (collageDisplay) {
            return (
                <div className="pdf-view-wrap">
                    <img src={LocalImages.pdfIcon} alt="pdfIcon" className="pdf-img"/>
                </div>
            )
        }

        pdfjs.GlobalWorkerOptions.workerSrc = new URL(
            'pdfjs-dist/build/pdf.worker.min.mjs',
            import.meta.url,
        ).toString();

        return (
            <div className="pdf-view-wrap">
                <Document 
                    file={media.media.url} 
                    onLoadSuccess={onDocumentLoadSuccess}
                    options={
                        {
                            standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`,
                        }
                    }
                >
                    {
                        numPages && [...Array(numPages)].map((x, i) => {
                            return (
                                <Page 
                                    pageNumber={i+1} 
                                    renderMode={"canvas"}
                                    onLoadSuccess={() => {
                                        if(numPages - 1 === i){
                                            setIsLoading(false)
                                        }
                                    }}
                                />
                            )
                        })
                    }
                </Document>
            </div>
        )
    }

    const renderImage = () => {
        if (collageDisplay) {
            return (
                <RenderImage mediaPath={mediaPath} customStyle={{ objectFit: 'cover' }} />
            )
        }

        return (
            <>
                <RenderImage mediaPath={mediaPath} customStyle={{ objectFit: 'contain' }} />
            </>
        )
    }

    return (
        <>
            {mediaType === MEDIA_TYPE.PDF && renderPDF()} {/* done */}
            {mediaType === MEDIA_TYPE.AUDIO && renderAudio()}
            {mediaType === MEDIA_TYPE.IMAGE && renderImage()} {/* done */}
            {mediaType === MEDIA_TYPE.VIDEO && renderVideo()}

        </>
    )
}

export default MediaTypeDisplay;